import Profile from '@/components/account/profile/index'
import ChangePassword from '@/components/account/changeInfo/ChangePassword'
import ChangeEmail from '@/components/account/changeInfo/ChangeEmail'
import ChangePhoneNumber from '@/components/account/changeInfo/ChangePhoneNumber'
import ConfirmEmail from '@/components/account/confirmInfo/confirmEmail'
import ConfirmPhoneNumber from '@/components/account/confirmInfo/confirmPhoneNumber'
import BasicInfo from '@/components/account/profile/BasicInfo'
import Signatories from '@/components/account/profile/signatories/index'
import BankAccounts from '@/components/account/profile/bankAccounts/index'
import Contacts from '@/components/account/profile/contacts/index'

export default {
  name: 'account',
  path: 'account',
  redirect: '/account/profile',
  meta: { auth: { allowUnconfirmedEmail: true, allowUnconfirmedPhoneNumber: true } },
  component: {
    render (c) { return c('router-view') }
  },
  children: [
    {
      path: 'profile',
      redirect: '/account/profile/index',
      meta: { auth: { allowUnconfirmedEmail: true, allowUnconfirmedPhoneNumber: true } },
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'index',
          meta: { auth: { allowUnconfirmedEmail: true, allowUnconfirmedPhoneNumber: true } },
          component: Profile
        },
        {
          path: 'basic-info',
          meta: { auth: true },
          component: BasicInfo
        },
        {
          path: 'signatories',
          meta: { auth: { statuses: ['inventoryDataApproved'] } },
          component: Signatories
        },
        {
          path: 'bank-accounts',
          meta: { auth: { statuses: ['inventoryDataApproved'] } },
          component: BankAccounts
        },
        {
          path: 'contacts',
          meta: { auth: { statuses: ['inventoryDataApproved'] } },
          component: Contacts
        }
      ]
    },
    {
      path: 'change-password',
      meta: { auth: { allowUnconfirmedEmail: true, allowUnconfirmedPhoneNumber: true } },
      component: ChangePassword
    },
    {
      path: 'change-email',
      meta: { auth: { allowUnconfirmedEmail: true, allowUnconfirmedPhoneNumber: true } },
      component: ChangeEmail
    },
    {
      path: 'change-phone-number',
      meta: { auth: { allowUnconfirmedEmail: true, allowUnconfirmedPhoneNumber: true } },
      component: ChangePhoneNumber
    },
    {
      path: 'confirm-email',
      meta: { auth: { allowUnconfirmedEmail: true, allowUnconfirmedPhoneNumber: true } },
      component: ConfirmEmail
    },
    {
      path: 'confirm-phone-number',
      meta: { auth: { allowUnconfirmedEmail: true, allowUnconfirmedPhoneNumber: true } },
      component: ConfirmPhoneNumber
    }
  ]
}
